import { styled } from 'styled-components';

export const Wrapper = styled.div`
    grid-column: 2 / span 1;

    min-height: 100%;
    height: 0; // For scroll behavior
    width: auto;
    position: relative;
    overflow: hidden;

    display: flex;
    align-items: center;
`;

export const Scrollable = styled.div<{ $isOpen: boolean }>`
    height: 100%;
    overflow-y: auto;

    display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
    transform: translateX(${({ $isOpen }) => ($isOpen ? '0%' : '100%')});
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
`;

export const Menu = styled.button`
    all: unset;
    width: 2rem;
    height: 100%;

    background: transparent;

    display: grid;
    place-content: center;

    &:hover {
        cursor: pointer;
        background-color: var(--color-accent-blue-10);
    }
`;
